import {
    adminRecipeCategoriesControllerGetCategories,
    adminRecipeCategoriesControllerCreateCategory,
    adminRecipeCategoriesControllerUpdateCategory,
    adminRecipeCategoriesControllerDeleteCategory,
} from "../api/generated";

// Migrated to the generated client. The server derives the company from the authed principal,
// so the endpoint has no `companyId` query param (the generated query type has none); the arg
// is kept for signature parity but not forwarded. Returns {data: RecipeCategoryDto[]} so
// callers keep reading `res.data`.
export const getRecipeCategories = async (companyId) => {
    const {data, error} = await adminRecipeCategoriesControllerGetCategories();
    if (error) throw error;
    return {data};
};

// Migrated. The request body is {name, icon, imageUrl} — the server ignores any extra
// `companyId` the caller passes (and the generated body type rejects it), so we forward only
// the modeled fields.
export const saveRecipeCategory = async (data) => {
    const {data: resData, error} = await adminRecipeCategoriesControllerCreateCategory({
        body: {name: data.name, icon: data.icon, imageUrl: data.imageUrl},
    });
    if (error) throw error;
    return {data: resData};
};

export const updateRecipeCategory = async (id, data) => {
    const {data: resData, error} = await adminRecipeCategoriesControllerUpdateCategory({
        path: {id},
        body: {name: data.name, icon: data.icon, imageUrl: data.imageUrl},
    });
    if (error) throw error;
    return {data: resData};
};

export const deleteRecipeCategory = async (id) => {
    const {data, error} = await adminRecipeCategoriesControllerDeleteCategory({path: {id}});
    if (error) throw error;
    return {data};
};
